/* eslint-disable id-length */
import { ForwardedChart, useChart } from "app/components/shared/Chart/chart";
import { linearFillGradient } from "./linearFillGradient";
import { ChartData } from "chart.js";
import Theme from "./Theme";
import { useEffect } from "react";

export function withDashedLine(dataset: any[]) {
  return {
    data: dataset,
    borderDash: [2, 3],
    borderWidth: 1,
    borderColor: "#8e8e8e",
  };
}

export function withGradientFillLine(dataset: any[], theme: Theme) {
  return {
    data: dataset,
    borderColor: theme.color,
    borderWidth: 1.75,
    fill: true,
    backgroundColor: linearFillGradient(theme.fillColors),
  };
}

export default function SparkLineChart({ data }: { data: ChartData }) {
  const { chartRef, updateData } = useChart();

  useEffect(() => {
    updateData(data);
  }, [data, updateData]);

  return (
    <ForwardedChart
      ref={chartRef}
      chartOptions={{
        type: "line",
        data,
        options: {
          layout: {
            padding: {
              top: 1,
              bottom: 1,
            },
          },
          animation: false,
          // Disable all interactions with the chart
          events: [],
          datasets: {
            line: {
              tension: 0.25,
              normalized: false,
              pointRadius: 0,
              borderWidth: 1.75,
              spanGaps: true,
            },
          },
          scales: {
            x: {
              display: false,
              grid: {
                display: false,
              },
            },
            y: {
              display: false,
              grid: {
                display: false,
              },
              beginAtZero: true,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      }}
    />
  );
}
